import React from "react"
import MediaQuery from "react-responsive"

import "./adSpace.scss"

const adSpace = props => {
  return (
    <div className="ad-space">
      <a href={props.link.href}>
        <MediaQuery minWidth={992}>
          <img
            src={props.desktop_image.url}
            alt={"DraftKings Product Ad Space"}
          />
        </MediaQuery>
        <MediaQuery minWidth={641} maxWidth={991}>
          <img
            src={props.tablet_image.url}
            alt={"DraftKings Product Ad Space"}
          />
        </MediaQuery>
        <MediaQuery minWidth={300} maxWidth={640}>
          <img
            src={props.mobile_image.url}
            alt={"DraftKings Product Ad Space"}
          />
        </MediaQuery>
      </a>
    </div>
  )
}

export default adSpace
